var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrophy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.833 5H17.833V4C17.833 3.45 17.383 3 16.833 3H8.83301C8.28301 3 7.83301 3.45 7.83301 4V5H5.83301C4.73301 5 3.83301 5.9 3.83301 7V8C3.83301 10.55 5.75301 12.63 8.22301 12.94C8.85301 14.44 10.203 15.57 11.833 15.9V19H8.83301C8.28301 19 7.83301 19.45 7.83301 20C7.83301 20.55 8.28301 21 8.83301 21H16.833C17.383 21 17.833 20.55 17.833 20C17.833 19.45 17.383 19 16.833 19H13.833V15.9C15.463 15.57 16.813 14.44 17.443 12.94C19.913 12.63 21.833 10.55 21.833 8V7C21.833 5.9 20.933 5 19.833 5ZM5.83301 8V7H7.83301V10.82C6.67301 10.4 5.83301 9.3 5.83301 8ZM19.833 8C19.833 9.3 18.993 10.4 17.833 10.82V7H19.833V8Z",
    fill: "#99ABB7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophy);
export default __webpack_public_path__ + "static/media/trophy.534f80571a13ffb84bce353197ef6504.svg";
export { ForwardRef as ReactComponent };